import Vue from 'vue'
import Router from 'vue-router'

import NavigationBar from '@/components/common/NavigationBar'
import QuestionnaireValidator from '@/components/common/QuestionnaireValidator'
import Main from '@/components/Main'
import Login from '@/components/Login'
import Profile from '@/components/profile/Profile'
import TokenRegistration from '@/components/TokenRegistration'
import Users from '@/components/users/Users'
import User from '@/components/users/User'
import NewUser from '@/components/users/newUser'
import Schools from '@/components/schools/Schools'
import School from '@/components/schools/School'
import NewSchool from '@/components/schools/newSchool'
import Questionnaires from '@/components/questionnaires/Questionnaires'
import Questionnaire from '@/components/questionnaires/Questionnaire'
import Recommendations from '@/components/questionnaires/Recommendations'
import Results from '@/components/results/Results'
import Result from '@/components/results/Result'
import Charts from '@/components/results/Charts'
import ItemsAggregate from '@/components/results/ItemsAggregate'
import ItemEvolution from '@/components/results/ItemEvolution'
import Grid from '@/components/Grid'
import Tutorial from '@/components/tutorial/TutorialSection'

Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      name: 'NoPath',
      components: {
        content: Login
      }
    },
    {
      path: '/login',
      name: 'Login',
      components: {
        content: Login
      }
    },
    {
      path: '/auth/registration',
      name: 'Registration',
      components: {
        content: TokenRegistration
      }
    },
    {
      path: '/home',
      name: 'Home',
      components: {
        navbar: NavigationBar,
        content: Main
      },
      meta: {auth: true}
    },
    {
      path: '/profile',
      name: 'Profile',
      components: {
        navbar: NavigationBar,
        content: Profile
      },
      meta: {auth: true}
    },
    {
      path: '/users',
      name: 'Users',
      meta: {auth: ['EXPERT']},
      components: {
        navbar: NavigationBar,
        content: Users
      }
    },
    {
      path: '/users/:userId',
      name: 'User',
      meta: {auth: ['EXPERT']},
      components: {
        navbar: NavigationBar,
        content: User
      }
    },
    {
      path: '/users/new',
      name: 'NewUser',
      meta: {auth: ['EXPERT']},
      components: {
        navbar: NavigationBar,
        content: NewUser
      }
    },
    {
      path: '/schools',
      name: 'Schools',
      meta: {auth: ['EXPERT']},
      components: {
        navbar: NavigationBar,
        content: Schools
      }
    },
    {
      path: '/schools/new',
      name: 'NewSchool',
      meta: {auth: ['EXPERT']},
      components: {
        navbar: NavigationBar,
        content: NewSchool
      }
    },
    {
      path: '/schools/:schoolId',
      name: 'School',
      meta: {auth: ['EXPERT']},
      components: {
        navbar: NavigationBar,
        content: School
      }
    },
    {
      path: '/questionnaires',
      name: 'Questionnaires',
      meta: {auth: true},
      components: {
        navbar: NavigationBar,
        content: Questionnaires
      }
    },
    {
      path: '/questionnaires/:questionnaireId',
      name: 'Questionnaire',
      meta: {auth: true},
      components: {
        navbar: NavigationBar,
        content: Questionnaire
      }
    },
    {
      path: '/questionnaires/:questionnaireId/result',
      name: 'Recommendations',
      meta: {auth: true},
      components: {
        navbar: NavigationBar,
        content: Recommendations
      }
    },
    {
      path: '/results',
      name: 'Results',
      meta: {auth: true},
      components: {
        navbar: NavigationBar,
        content: Results
      }
    },
    {
      path: '/results/:questionnaireId',
      name: 'Result',
      meta: {auth: true},
      components: {
        navbar: NavigationBar,
        content: Result
      }
    },
    {
      path: '/charts',
      name: 'Charts',
      meta: {auth: true},
      components: {
        navbar: NavigationBar,
        content: Charts
      }
    },
    {
      path: '/stats',
      name: 'Statistics',
      meta: {auth: true},
      components: {
        navbar: NavigationBar,
        content: ItemsAggregate
      }
    },
    {
      path: '/itemStats',
      name: 'ItemStatistics',
      meta: {auth: true},
      components: {
        navbar: NavigationBar,
        content: ItemEvolution
      }
    },
    {
      path: '/validator',
      name: 'QuestionnaireValidator',
      meta: {auth: ['EXPERT']},
      components: {
        navbar: NavigationBar,
        content: QuestionnaireValidator
      }
    },
    {
      path: '/items',
      name: 'Grid',
      meta: {auth: true},
      components: {
        navbar: NavigationBar,
        content: Grid
      }
    },
    {
      path: '/tutorial',
      name: 'Tutorial',
      meta: {auth: true},
      components: {
        navbar: NavigationBar,
        content: Tutorial
      }
    }
  ],
  linkActiveClass: 'custom-router-link-active',
  linkExactActiveClass: 'custom-router-link-active'
})



// WEBPACK FOOTER //
// ./src/router/index.js